import { Signal } from '@preact/signals-react';
import produce from 'immer';
import { EditorDeclarativeBlock } from '@/webapi/use-experience-api';
import { CompoundChange } from '@/pkg/sdk';
import { AiComponentVisualManifest } from '@/pkg/ai';

export interface CodeMutations {
  setHtml: (html: string) => void;
  setCss: (css: string) => void;
  setJs: (js: string) => void;
  setEditManifest: (manifest: string) => void;
}

export function useCodeMutations(
  newChange: Signal<EditorDeclarativeBlock>,
): CodeMutations {
  const setHtml = (html: string) => {
    newChange.value = produce(newChange.value, (draft) => {
      (draft.block.value as CompoundChange).html = html;
    });
  };

  const setCss = (css: string) => {
    newChange.value = produce(newChange.value, (draft) => {
      (draft.block.value as CompoundChange).css = css;
    });
  };

  const setJs = (js: string) => {
    newChange.value = produce(newChange.value, (draft) => {
      (draft.block.value as CompoundChange).js = js;
    });
  };

  const setEditManifest = (manifest: string) => {
    try {
      const parsedManifest = JSON.parse(manifest) as AiComponentVisualManifest;
      newChange.value = produce(newChange.value, (draft) => {
        (draft.block.value as CompoundChange).editManifest = parsedManifest;
      });
    } catch (error) {
      console.error(`Failed to parse edit manifest:`, error);
    }
  };

  return {
    setHtml,
    setCss,
    setJs,
    setEditManifest,
  };
}
